import React from 'react';

const PayrollApproval = () => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Payroll Approval</h2>
      <p className="text-sm text-gray-600">Approval workflow views will be added here.</p>
    </div>
  );
};

export default PayrollApproval;
